<template>
  <div>
    <p class="text-medium-grey text-justify">
      Inserisci almeno nome e servizio di riferimento per la nuova attività.
    </p>
    <b-form @submit.prevent="sendForm" class="text-left fw-bolder">
      <b-form-group id="name" label="Nome*:" label-for="name">
        <b-form-input id="name" v-model="form.name" type="text" placeholder="Nome attività.." class="shadow_6" required>
        </b-form-input>
      </b-form-group>
      <b-form-group id="description" label="Descrizione:" label-for="description">
        <b-form-input id="description" v-model="form.description" type="text" placeholder="Descrizione attività.."
          class="shadow_6"></b-form-input>
      </b-form-group>
      <b-form-group id="service" label="Servizio*:" label-for="description">
        <b-form-select name="service" class="shadow_6 text-capitalize" v-model="form.position_ref" required>
          <b-form-select-option :value="1">facile prestazioni</b-form-select-option>
          <b-form-select-option :value="2">connessa</b-form-select-option>
          <b-form-select-option :value="3">con te</b-form-select-option>
        </b-form-select>
      </b-form-group>
      <p class="text-medium-grey text-justify" v-if="form.position_ref == 1">
        I questionari per il servizio "Facile - prestazioni" possono essere
        associati alle prestazioni (tramite la pagina impostazioni->gestione
        servizi->prestazioni). Le prenotazioni di prestazioni associate a
        questionario proporranno all'utente che desidera prenotare il
        questionario associato come step obbligatorio per la conclusione della
        procedura.
      </p>
      <p class="text-medium-grey text-justify" v-else-if="form.position_ref == 2">
        I questionari per il servizio "Connessa", quando abilitati, vengono
        proposti ai pazienti che richiedono un teleconsulto: in fase di
        prenotazione per finalizzare la richiesta l'utente dovrà selezionare un
        questionario e compilarlo .
      </p>
      <p class="text-medium-grey text-justify" v-else>
        I questionari del servizio "Con Te" sono pensati per le attività di
        screening: puoi somministrarli ai tuoi pazienti compilandoli di persona.
      </p>
      <b-form-group label="Attiva:">
        <b-form-checkbox id="enabled" v-model="form.enabled" name="enabled" :checked-value="true">
          Attività abilitata
        </b-form-checkbox>
      </b-form-group>
      <div class="text-center">
        <b-button type="submit" variant="primary primary_gradient text-white fw-bolder spacing_1">Crea attività
        </b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
import { supportService } from "@/_services";
import { mapState, mapActions } from "vuex";
export default {
  name: "NuovaAttivita",
  props: ["position"],
  data() {
    return {
      form: {
        name: null,
        description: null,
        enabled: true,
        position_ref: 3,
      },
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    sendForm(e) {
      e.preventDefault();
      var self = this;
      supportService
        .storeActivity(this.form)
        .then(function (res) {
          // //console.log(res);
          self.$emit("activity-created", true);
        })
        .catch(function (err) {
          console.log(err);

          self.$emit("activity-created", false);
        });
    },
  },
  created() {
    if (this.position) {
      this.form.position_ref = this.position;
    }
  },
};
</script>